import { useState, useEffect } from "react";
import { ModalBody, ModalHeader, Modal, Row, Col, Button } from "reactstrap";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// select
import Select from "react-select";
// componentes
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";
import ColorPicker from "../../../components/ColorPicker/ColorPicker";
import ModalIcons from "./ModalIcons";
// services
import { getGroups } from "../../../utils/services/group";
import { edit } from "../../../utils/services/portalEvents/portalEventsButtonsMenu";

export default function ModalEditMenu(props) {
  const { isOpen, toggle, idEvent, getListButtons, selectedToEdit } = props;
  // form
  const [form, setForm] = useState({});
  const [color, setColor] = useState("#FFFF");
  const [iconSelected, setIconSelected] = useState(null);
  const [groups, setGroups] = useState([]);
  const [allGroups, setAllGroups] = useState(false);
  // erros
  const [errors, setErrors] = useState({});
  // carregamento
  const [loading, setLoading] = useState(false);
  const [loadingForm, setLoadingForm] = useState(true);
  // modal
  const [modalIcon, setModalIcon] = useState(false);
  // alerta
  const [success, setSuccess] = useState(false);

  function handleGroupMulti(a) {
    const selected = a.filter((e) => e.value === "todos");
    if (selected.length > 0) {
      a = selected;
      setAllGroups(true);
    } else {
      setAllGroups(false);
    }

    setForm({
      ...form,
      groupsMulti: a,
    });
  }

  function validForm() {
    setLoading(true);

    if (!form.typeButton) {
      setErrors({
        typeButton: "O campo Tipo do Botão é obrigatório",
      });
      setLoading(false);
      return;
    } else if (form.typeButton === "Outro" && !form.otherTypeButton) {
      setErrors({
        otherTypeButton: "Especificar o Tipo do Botão é obrigatório",
      });
      setLoading(false);
      return;
    } else if (!form.url) {
      setErrors({
        url: "O campo URL é obrigatório",
      });
      setLoading(false);
      return;
    } else if (!form.name) {
      setErrors({
        name: "O campo Nome de Exibição é obrigatório",
      });
      setLoading(false);
      return;
    } else setErrors({}) > submitForm();
  }

  function submitForm() {
    var groupsApi = "";

    if (form.groupsMulti.length === 0) {
      groupsApi = "";
    } else if (form.groupsMulti.find((e) => e.value === "todos")) {
      groupsApi = groups
        .map((e) => {
          return e.id;
        })
        .join(", ");
    } else {
      groupsApi = form.groupsMulti
        .map((e) => {
          return e.value;
        })
        .join(", ");
    }

    const data = {
      eventId: idEvent,
      order: selectedToEdit.order,
      type: form.typeButton,
      url: form.url,
      name: form.name,
      icon: iconSelected || "",
      color: color,
      groupsId: groupsApi,
      isVisible: form.isVisible,
      startDate: null,
      endDate: null,
      external: form.external,
    };

    edit(data, form.id)
      .then((res) => {
        if (res.message === "updated") {
          setLoading(false);
          setSuccess(true);
        }
      })
      .catch((error) => console.log("erro", error));
  }

  async function getGroupsFunc() {
    var groupsApi = [];

    await getGroups({
      eventId: idEvent,
      offset: 1,
      limit: 0,
      search: "",
    })
      .then((res) => {
        if (
          res.message === "Groups_by_event" &&
          res.findOneGroupData.count > 0
        ) {
          setGroups(res.findOneGroupData.data);

          if (selectedToEdit.grupos?.length > 0) {
            if (
              selectedToEdit.grupos.length === res.findOneGroupData.data.length
            ) {
              groupsApi = [{ label: "TODOS", value: "todos" }];
            } else {
              groupsApi = selectedToEdit.grupos.map((e) => {
                return {
                  label: e.name,
                  value: e.id,
                };
              });
            }
          }
        } else setGroups([]);

        setForm({
          typeButton: selectedToEdit.type,
          url: selectedToEdit.url,
          name: selectedToEdit.name,
          groupsMulti: groupsApi,
          isVisible: selectedToEdit.isVisible,
          external: selectedToEdit.external,
          dateStart: "",
          dateEnd: "",
          id: selectedToEdit.id,
        });
        setColor(selectedToEdit.color);
        setIconSelected(selectedToEdit.icon);

        setLoadingForm(false);
      })
      .catch((error) => {
        // console.log(error);
      });
  }

  useEffect(() => {
    getGroupsFunc();
  }, []);

  if (loadingForm) {
    return (
      <Modal isOpen={isOpen} centered>
        <ModalHeader toggle={toggle}>Editar Botão</ModalHeader>
        <ModalBody style={{ textAlign: "center" }}>
          <a>Carregando ...</a>
        </ModalBody>
      </Modal>
    );
  } else
    return (
      <>
        {modalIcon && (
          <ModalIcons
            isOpen={modalIcon}
            toggle={() => setModalIcon(false)}
            setIconSelected={setIconSelected}
            iconSelected={iconSelected}
          />
        )}

        {success && (
          <SweetAlert
            success
            title="Sucesso"
            onConfirm={() => {
              getListButtons();
              toggle();
              setSuccess(false);
            }}
          >
            Botão criado com sucesso!
          </SweetAlert>
        )}

        <Modal isOpen={isOpen} centered>
          <ModalHeader toggle={toggle}>Editar Botão</ModalHeader>
          <ModalBody>
            <Row>
              <Col lg={12}>
                <label className="form-label">ID</label>
                <input
                  className="form-control"
                  type="text"
                  value={form.id}
                  disabled
                />
              </Col>
            </Row>

            <Row style={{ paddingTop: 10 }}>
              <Col lg={12}>
                <label className="form-label">Tipo do Botão</label>
                <input
                  className="form-control"
                  type="text"
                  value={form.typeButton}
                  disabled
                />
              </Col>
            </Row>

            <Row style={{ paddingTop: 10 }}>
              <Col lg={12}>
                <label className="form-label">URL*</label>
                <input
                  className="form-control"
                  type="text"
                  value={form.url}
                  onChange={(e) => setForm({ ...form, url: e.target.value })}
                />
                {errors && errors.url && (
                  <a style={{ color: "red" }}>{errors.url}</a>
                )}
              </Col>
            </Row>

            <Row style={{ paddingTop: 10 }}>
              <Col lg={12}>
                <label className="form-label">Nome de Exibição*</label>
                <input
                  className="form-control"
                  type="text"
                  value={form.name}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      name: e.target.value,
                    })
                  }
                />
                {errors && errors.name && (
                  <a style={{ color: "red" }}>{errors.name}</a>
                )}
              </Col>
            </Row>

            <Row style={{ paddingTop: 10 }}>
              <Col lg={12}>
                <ColorPicker
                  classOfContainer="color"
                  labelText="Cor*"
                  setStateFunc={setColor}
                  defaultColor={color}
                  idDiv={"color"}
                />
              </Col>
            </Row>

            <Row style={{ marginTop: 10 }}>
              <Col lg={12}>
                <label className="form-label">Ícone</label>
                <div
                  className="form-control"
                  style={{ textAlign: "center" }}
                  type={"text"}
                >
                  {iconSelected ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <i className={iconSelected} />

                      <i
                        className="mdi mdi-trash-can icon-trash"
                        onClick={() => {
                          setIconSelected(null);
                        }}
                      />
                    </div>
                  ) : (
                    <span
                      onClick={() => setModalIcon(true)}
                      style={{ cursor: "pointer" }}
                    >
                      Selecione
                    </span>
                  )}
                </div>
              </Col>
            </Row>

            <Row style={{ paddingTop: 10 }}>
              <Col lg={12}>
                <label className="form-label">Grupos</label>
                <Select
                  placeholder={"Selecione"}
                  isMulti
                  value={form && form.groupsMulti}
                  onChange={(e) => {
                    handleGroupMulti(e);
                  }}
                  noOptionsMessage={() => "Nenhuma opção encontrada"}
                  options={[
                    {
                      options:
                        groups?.length > 0 && !allGroups
                          ? [
                              { label: "TODOS", value: "todos" },
                              ...groups.map((e) => {
                                return { label: e.name, value: e.id };
                              }),
                            ]
                          : [],
                    },
                  ]}
                  classNamePrefix="select2-selection"
                />
              </Col>
            </Row>

            <Row style={{ marginTop: 20, marginBottom: 20 }}>
              <Col md={6}>
                <div className="form-check form-check-end">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={form.isVisible}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        isVisible: e.target.checked,
                      })
                    }
                  />
                  <label>Visível</label>
                </div>
              </Col>

              <Col md={6}>
                <div className="form-check form-check-end">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={form.external}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        external: e.target.checked,
                      })
                    }
                  />
                  <label>Externo</label>
                </div>
              </Col>
            </Row>

            {/* {form.isVisible && (
              <Row>
                <Col md={6} style={{ marginTop: 10 }}>
                  <label className="form-label">Data e Hora Inicio*</label>
                  <input
                    className="form-control"
                    type="datetime-local"
                    name="startDateTime"
                    value={form.dateStart || ""}
                    max={(form && form.dateEnd) || ""}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        dateStart: e.target.value,
                      })
                    }
                  />
                  {errors && errors.dateStart && (
                    <a style={{ color: "red" }}>{errors.dateStart}</a>
                  )}
                </Col>
                <Col md={6} style={{ marginTop: 10 }}>
                  <label className="form-label">Data e Hora Fim*</label>
                  <input
                    className="form-control"
                    type="datetime-local"
                    name="endDateTime"
                    value={form.dateEnd || ""}
                    min={(form && form.dateStart) || ""}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        dateEnd: e.target.value,
                      })
                    }
                  />
                  {errors && errors.dateEnd && (
                    <a style={{ color: "red" }}>{errors.dateEnd}</a>
                  )}
                </Col>
              </Row>
            )} */}

            <Row
              style={{
                width: "100%",
                margin: "auto",
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 20,
              }}
            >
              <Button
                color="success"
                className="btn btn-danger waves-effect waves-light"
                style={{ width: 80, marginRight: 5 }}
                onClick={() => toggle()}
              >
                Fechar
              </Button>
              <ButtonSpinner
                title={"Salvar"}
                isLoading={loading}
                onClick={() => validForm()}
              />
            </Row>
          </ModalBody>
        </Modal>
      </>
    );
}
